var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 169 169",
    style: {
      enableBackground: "new 0 0 169 169"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#EC008C;}\n\t.st2{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFF00;}\n\t.st4{display:inline;}\n\t.st5{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.5,
    cy: 84.5,
    r: 84.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.9,122.3c0.7,0.4,1.4,0.4,2.1,0c1.3-0.9,2.5-2,3.5-3.3c1.5-1.8,2.8-3.7,4.3-5.7l2.1,1.3 c-3,5-6.1,9.7-10.7,13.1c-2.4,1.9-5.3,3.1-8.4,3.5c-7.2,0.8-11.7-4.1-10-11.1c1.5-6.2,3.4-12.2,5.1-18.4c1.7-6.1,3.5-12.5,5.3-18.7 c0.1-0.6,0.2-1.2,0.3-1.9c0.3-1.1,0.1-2.2-0.6-3.1s-1.6-1.4-2.7-1.5s-2.2-0.1-3.3-0.1c0-0.4,0.1-0.7,0.2-1.1l0.2-1.5l25.9-4.1 L97.4,76l0,0L97,77.6c-3.8,13.1-7.5,26.2-11.3,39.4c-0.4,1-0.6,2.1-0.7,3.2C85,121,85.3,121.8,85.9,122.3L85.9,122.3z M92.1,55.5 c-2.5,0-4.9-1-6.6-2.8s-2.7-4.2-2.7-6.6c0-5.1,4.2-9.3,9.3-9.3s9.3,4.2,9.3,9.3C101.5,51.3,97.3,55.5,92.1,55.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gabelschl\\xFCssel",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 84.5,
    cy: 84.5,
    r: 84.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M128.3,72.4c6.3-6.3,8-15.3,5.4-23.2l-14.1,14.1l-10.3-3.6l-3.6-10.3l14.1-14.1c-7.8-2.7-16.9-0.9-23.2,5.4 C90.3,47,88.5,56.1,91.3,64l-52.2,47.6l-1.2,1.2c-5.1,5.1-5.1,13.2,0,18.3c5.1,5.1,13.2,5.1,18.3,0l1.2-1.2L105,77.7 C112.9,80.5,122,78.7,128.3,72.4z M41.9,127.1c-2.8-2.8-2.8-7.4,0-10.2c2.8-2.8,7.4-2.8,10.2,0s2.8,7.4,0,10.2 C49.4,129.9,44.8,129.9,41.9,127.1z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.7,37.8C116,12,74,12,48.3,37.8C36.1,50,29.7,65.8,29,81.8H8L39.3,127l31.4-45.2h-23c0.6-11.2,5.2-22.3,13.7-30.8 C80,32.5,110,32.5,128.5,51s18.5,48.6,0,67.1c-17.3,17.3-44.8,18.4-63.4,3.3L54.9,137c25.9,19.8,63.2,17.9,86.8-5.8 C167.5,105.5,167.5,63.5,141.7,37.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.e3fbd67bb87058f7d8cb8abfb37c4c8d.svg";
export { ForwardRef as ReactComponent };